import AlertBadgesType from "@app/enum/map/AlertBadgesType";
import {
  ENTITY_BADGE_ALERT_COLOR,
  ENTITY_BADGE_INFO_COLOR,
  ENTITY_BADGE_WARNING_COLOR,
} from "@app/util/badge/const";

const getColorByBadgeType = (type: AlertBadgesType): string => {
  if (type === AlertBadgesType.OVERDUE) {
    return ENTITY_BADGE_ALERT_COLOR;
  }
  if (type === AlertBadgesType.OUT_OF_CADENCE_SOON) {
    return ENTITY_BADGE_WARNING_COLOR;
  }
  return ENTITY_BADGE_INFO_COLOR;
};

export default getColorByBadgeType;
